// pdf.js worker configuration for react-pdf, isolated so any module that needs
// the reader just `import "./pdfSetup"` (side-effect) before rendering a
// <Document>. Importing here (not in src/index.js) keeps the worker setup out
// of the global bundle's critical path — it loads with the Materials chunk.
//
// The worker is served from jsDelivr PINNED TO THE INSTALLED pdfjs version
// (`pdfjs.version`), so the worker version can never drift from the API version
// that react-pdf bundles — a mismatch throws "API version does not match Worker
// version" at runtime. jsDelivr mirrors the exact npm release (cdnjs can lag a
// few patch versions behind, which would reintroduce that mismatch).
//
// pdfjs-dist v4+ ships the worker as an ES module (`.mjs`); older majors shipped
// `.js`. If this is ever pinned back to react-pdf@7 / pdfjs-dist v3, flip the
// extension below to `.min.js`.
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
